export default {
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_LOCATIONS: "SET_LOCATIONS",
  SET_MARINAS: "SET_MARINAS",
  SET_DEPARTURE_PORTS: "SET_DEPARTURE_PORTS",
};
